import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  Chip,
  LogoLoader,
  Modal,
  showToast,
} from "../../../../components";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { pullMonsterCandidateResume } from "../../../../redux/slices/internalDbES/internalDbESApi";
import { getMonsterResumeImport } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import {
  getMonsterApplicantsDataStart,
  updateCareerBuilderApplicantsDataStart,
  updateMonsterApplicantsDataStart,
} from "../../../../redux/slices/internalDbES/internalDbESlice";
import {
  getAllApplicantsDataStart,
  getCareerBuilderApplicantsDataStart,
  setStateLoading,
  revertStateLoading,
} from "../../../../redux/slices/internalDbES/internalDbESlice";
import { useDispatch, useSelector } from "react-redux";
import { dateFormator } from "../../../../utils";
import { formatWords2 } from "../../../../utils/stringUtils";
import ProfileMigrationModel from "../Modals/ProfileMigrationModel";
import { fixResumeIfEntities } from "../../../../utils/resumeFixer";
import { setcareerBuilderAccessidStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import { setMonsterAccessidStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import axiosRequest from "../../../../redux/slices/universal/axiosService";

const actionMap = {
  1: getAllApplicantsDataStart,
  2: getCareerBuilderApplicantsDataStart,
  3: getMonsterApplicantsDataStart,
};

const getJobBoardsName = {
  1: "Internal DB",
  2: "Career Builder",
  3: "Monster",
};
function tokenizeKeywords(keywords = []) {
  return keywords.flatMap((kw) =>
    kw
      .replace(/[“”]/g, '"')
      .split(/\s+/) // split by space
      .map((w) => w.trim())
      .filter(Boolean)
  );
}

// function countKeywordsInResume(htmlResume = "", keywords = []) {
//   if (!htmlResume || !Array.isArray(keywords) || keywords.length === 0) {
//     return [];
//   }

//   const excludeWords = new Set(["and", "or", "not"]);
//   const plainText = htmlResume.replace(/<[^>]*>/g, " ").toLowerCase();
//   const uniqueKeywords = [...new Set(
//     keywords
//       .filter((kw) => typeof kw === "string" && kw.trim())
//       .map((kw) => kw.trim().toLowerCase())
//   )];

//   return uniqueKeywords.map((kw) => {
//     if (excludeWords.has(kw)) {
//       return { title: kw, value: 0 };
//     }
//     const escaped = kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//     const regex = new RegExp(`\\b${escaped}\\b`, "gi");
//     const matches = plainText.match(regex);
//     return {
//       title: kw,
//       value: matches ? matches.length : 0,
//     };
//   });
// }
function countKeywordsInResume(htmlResume = "", keywords = []) {
  if (!htmlResume || !Array.isArray(keywords) || keywords.length === 0) {
    return [];
  }

  const excludeWords = new Set(["and", "or", "not"]);
  const plainText = fixResumeIfEntities(htmlResume).replace(/<[^>]*>/g, " ").toLowerCase();
  const uniqueKeywords = [...new Set(
    keywords
      .filter((kw) => typeof kw === "string" && kw.trim())
      .map((kw) => kw.trim().toLowerCase())
  )];

  return uniqueKeywords.map((kw) => {
    if (excludeWords.has(kw)) {
      return { title: kw, value: 0 };
    }

    let regex;

    if (kw.endsWith("*")) {
      const stem = kw.slice(0, -1).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

      //  Match repair, repairs, repairing, repaired, repairman etc
      regex = new RegExp(`${stem}\\w*`, "gi");
    } else {
      const escaped = kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const pattern = escaped.replace(/ +/g, "\\s+");
      regex = new RegExp(`\\b${pattern}\\b`, "gi");
    }

    const matches = plainText.match(regex);
    return {
      title: kw,
      value: matches ? matches.length : 0,
    };
  });
}

// function highlightKeywordsInHtmlResume(htmlResume = "", keywords = []) {
//   if (!htmlResume) { //|| !Array.isArray(keywords) || keywords.length === 0
//     return htmlResume;
//   }
//   const isPlainText = !/<\/?(p|div|span|table|html|body)/i.test(htmlResume);

//   if (isPlainText && !htmlResume.includes("<pre>")) {
//     htmlResume = `<pre>${htmlResume}</pre>`;
//   }

//   // Exclude generic words
//   const fixedResume = fixResumeIfEntities(htmlResume)
//   const excluded = new Set(["and", "or", "not"]);
//   const validKeywords = keywords
//     .filter(
//       (kw) => typeof kw === "string" && kw.trim() && !excluded.has(kw.toLowerCase())
//     )
//     .map((kw) => kw.trim()).sort((a, b) => b.length - a.length);

//   if (validKeywords.length === 0) return fixedResume;

//   // Escape regex special chars and build one combined regex
//   // const escaped = validKeywords.map((kw) =>
//   //   kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
//   // );
//   //const regex = new RegExp(`\\b(${escaped.join("|")})\\b`, "gi");
//   const regex = new RegExp(
//     `(${validKeywords
//       .map(kw =>
//         kw.endsWith("*")
//           ? `\\b${kw.slice(0, -1).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\w*`
//           : `\\b${kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`
//       )
//       .join("|")})`,
//     "gi"
//   );


//   // Replace matches with <mark>
//   const highlighted = fixedResume.replace(regex, (match) => {
//     return `<mark class="highlight">${match}</mark>`;
//   });

//   return highlighted;
// }
// function highlightKeywordsInHtmlResume(htmlResume = "", keywords = []) {
//   if (!htmlResume) return htmlResume;

//   const isPlainText = !/<\/?(p|div|span|table|html|body)/i.test(htmlResume);
//   if (isPlainText && !htmlResume.includes("<pre>")) {
//     htmlResume = `<pre>${htmlResume}</pre>`;
//   }

//   const fixedResume = fixResumeIfEntities(htmlResume);
//   const excluded = new Set(["and", "or", "not"]);
//   const validKeywords = keywords
//     .filter((kw) => typeof kw === "string" && kw.trim() && !excluded.has(kw.toLowerCase()))
//     .map((kw) => kw.trim())
//     .sort((a, b) => b.length - a.length);

//   if (validKeywords.length === 0) return fixedResume;

//   const regex = new RegExp(
//     `(${validKeywords
//       .map((kw) =>
//        kw.endsWith("*")
//   ? `\\b${kw.slice(0, -1).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`
//           : `\\b${kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`
//       )
//       .join("|")})`,
//     "gi"
//   );

//   // ✅ Split by HTML tags, only replace in TEXT parts (not inside < > tags)
//   const highlighted = fixedResume.replace(
//     /(<[^>]*>)|([^<]+)/g,
//     (match, tag, text) => {
//       if (tag) return tag; // inside a tag — don't touch it
//       if (text) return text.replace(regex, (m) => `<mark class="highlight">${m}</mark>`);
//       return match;
//     }
//   );

//   return highlighted;
// }
function highlightKeywordsInHtmlResume(htmlResume = "", keywords = []) {
  if (!htmlResume) return htmlResume;

  const isPlainText = !/<\/?(p|div|span|table|html|body)/i.test(htmlResume);
  if (isPlainText && !htmlResume.includes("<pre>")) {
    htmlResume = `<pre>${htmlResume}</pre>`;
  }

  const fixedResume = fixResumeIfEntities(htmlResume);
  const excluded = new Set(["and", "or", "not"]);
  const validKeywords = keywords
    .filter((kw) => typeof kw === "string" && kw.trim() && !excluded.has(kw.toLowerCase()))
    .map((kw) => kw.trim())
    .sort((a, b) => b.length - a.length);

  if (validKeywords.length === 0) return fixedResume;

  // ── 1. Parse HTML into tag/text segments ────────────────────────────────
  const segments = [];
  const splitRegex = /(<[^>]*>)|([^<]+)/g;
  let m;
  while ((m = splitRegex.exec(fixedResume)) !== null) {
    segments.push(
      m[1] ? { type: "tag",  content: m[1] }
            : { type: "text", content: m[2] }
    );
  }

  // ── 2. Build combined text + position map ───────────────────────────────
  // posMap[i] = { segIdx, pos } — where char i in `combined` came from
  //           | null            — synthetic space injected between segments
  let combined = "";
  const posMap  = [];

  for (let si = 0; si < segments.length; si++) {
    if (segments[si].type !== "text") continue;
    const { content } = segments[si];

    // Inject one space between text segments so word boundaries are maintained,
    // but only when neither side already provides whitespace.
    if (combined.length > 0 && !/\s$/.test(combined) && !/^\s/.test(content)) {
      combined += " ";
      posMap.push(null);           // synthetic — belongs to no segment
    }

    for (let ci = 0; ci < content.length; ci++) {
      combined += content[ci];
      posMap.push({ segIdx: si, pos: ci });
    }
  }

  // ── 3. Build regex — spaces in keywords become \s+ ──────────────────────
  //    This lets "technical mechanic" match across a newline or other whitespace.
  const regex = new RegExp(
    `(${validKeywords
      .map((kw) => {
        const base    = kw.endsWith("*") ? kw.slice(0, -1) : kw;
        const escaped = base.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const pattern = escaped.replace(/ +/g, "\\s+"); // ← key change
        return kw.endsWith("*") ? `\\b${pattern}\\w*` : `\\b${pattern}\\b`;
      })
      .join("|")})`,
    "gi"
  );

  // ── 4. Find all matches in combined text ────────────────────────────────
  const allMatches = [];
  let match;
  while ((match = regex.exec(combined)) !== null) {
    allMatches.push({ start: match.index, end: match.index + match[0].length });
  }

  if (allMatches.length === 0) return fixedResume;

  // ── 5. Map each match range back to per-segment highlight ranges ─────────
  // segHighlights: Map<segIdx, Array<{start, end}>>  (local char offsets)
  const segHighlights = new Map();

  for (const { start, end } of allMatches) {
    let i = start;
    while (i < end) {
      const pm = posMap[i];
      if (pm === null) { i++; continue; }          // skip synthetic spaces

      const { segIdx } = pm;
      const startPos   = pm.pos;

      // Advance while still in the same segment
      let j = i + 1;
      while (j < end && posMap[j] !== null && posMap[j].segIdx === segIdx) j++;

      const endPos = posMap[j - 1].pos + 1;

      if (!segHighlights.has(segIdx)) segHighlights.set(segIdx, []);
      segHighlights.get(segIdx).push({ start: startPos, end: endPos });
      i = j;
    }
  }

  // ── 6. Rebuild HTML, injecting <mark> tags into text segments ────────────
  return segments
    .map((seg, si) => {
      if (seg.type === "tag") return seg.content;

      const ranges = segHighlights.get(si);
      if (!ranges || ranges.length === 0) return seg.content;

      ranges.sort((a, b) => a.start - b.start);

      let out = "";
      let cursor = 0;
      for (const { start, end } of ranges) {
        out += seg.content.slice(cursor, start);

        const slice = seg.content.slice(start, end);
        // Don't wrap pure whitespace (e.g. a lone \n between tags)
        out += slice.trim()
          ? `<mark class="highlight">${slice}</mark>`
          : slice;

        cursor = end;
      }
      out += seg.content.slice(cursor);
      return out;
    })
    .join("");
}

const Resume = ({ isOpen, source, candidate, keywords, searchQuery, loading = false, onClose: drawerClose }) => {
  const resumeLink = candidate?.resumes?.at(-1)?.files?.at(-1)?.key ?? "";
  const isDisabled = !resumeLink;
  const { user } = useSelector((state) => state.auth);
  const orgName = user?.data?.organizationId?.name;
  const isParent = user?.data?.organizationId?.isParent == true;
  const { loginUserUiid } = useLoginUser();
  const dispatch = useDispatch();
  const [getResume, setGetResume] = useState(false);
  const [viewData, setViewData] = useState("");
  const [hasFetched, setHasFetched] = useState(false);
  const [showOriginal, setShowOriginal] = useState(false); // false = highlighted (default)
  const [cbAccessId, setCbAccessId] = useState(null);
  const [monsterAccessId, setMonsterAccessId] = useState(null);
  const [isMergeModel, setIsMergeModel] = useState(false);
  const [cbExistingResponse, setCbExistingResponse] = useState();
  // const [monsterExistingResponse, setMonsterExistingResponse] = useState();

  const { careerBuilder } = useSelector((state) => state.internalDbES);
  const { tableResponse, fullResponse, existingCandidates } = careerBuilder;

  const { monster } = useSelector((state) => state.internalDbES);
  const {
    tableResponse: mTableResponse,
    fullResponse: mFullResponse,
    existingCandidates: mExistingCandidates,
  } = monster;
  const { accessData } = useSelector((state) => state.internalDbES);
  //console.log(loading)
  // Get Resume Helper
  const downloadResumeForCandidate = async () => {
    dispatch(setStateLoading());

    switch (source) {
      case 2: {
        const candidateData = {
          accessId: cbAccessId,
          userId: user?.data?.uiid,
          payload: {
            source: 2,
            resumeId: candidate?.resumeId,
            // resumeId: "RQS2C96154NXMT15JD0",
            addedBy: loginUserUiid,
            jobTitle: candidate?.jobTitle || candidate?.resumeTitle,
            skills: keywords,
          },
          childCredentials: null,
          isChild: isParent ? false : true
        };

        try {
          const response = await pullMonsterCandidateResume(candidateData);
          const newCandidate = response?.data?.data?.response;
          const cBExistingCandidates = response?.field?.existingCandidates || [];

          if (response.success) {
            if (
              response?.data?.data?.response?.message ===
              "Candidate Already Exists"
            ) {
              setIsMergeModel(true);
              setCbExistingResponse(response?.data?.data?.response);
            } else {
              const existing = candidate;
              dispatch(
                updateCareerBuilderApplicantsDataStart({
                  existing,
                  newCandidate,
                  tableResponse,
                  fullResponse,
                  existingCandidates,
                })
              );
              // dispatch(selectedAction({
              //   ...searchQuery, onSuccess: () => {
              //     showToast("Resume Pulled Successflly.")
              //     drawerClose();
              //   }
              // }));
            }
          } else {
            if (response?.error == "Candidate already exists with the resumeId") {
              const existing = candidate;
              dispatch(
                updateCareerBuilderApplicantsDataStart({
                  existing,
                  newCandidate: cBExistingCandidates[0] || {},
                  tableResponse,
                  fullResponse,
                  existingCandidates
                })
              );
              showToast("Resume pulled successfully", "success", 2000);
            } else {
              if (response?.error) {
                showToast(response?.error, "error", 2000);
              } else {
                showToast("Resume Pulling Unsuccessful.", "error", 2000);
              }
              drawerClose();
            }
            dispatch(revertStateLoading());
          }
        } catch (error) {
          showToast("Something went wrong.", "error");
          drawerClose();
          dispatch(revertStateLoading());
        }

        break;
      }

      case 3: {
        const candidateData = {
          accessId: monsterAccessId,
          payload: {
            resumeId: candidate?.resumeId,
            resumeBoardId: 1,
            firstName: candidate?.firstName,
            middleName: "",
            lastName: candidate?.lastName,
            addedBy: loginUserUiid,
            jobTitle:
              candidate?.experienceJobTitle || candidate?.jobTitle || "N/A",
            workAuth:
              `${candidate?.workAuthCountry} ${candidate?.workAuthType}`.trim(),
            workHistory: [
              {
                companyName: candidate?.experienceCompany || "",
                jobDetails: {
                  title: candidate?.experienceJobTitle || "",
                },
              },
            ],
            militaryExp: {},
            educationDetails: [
              {
                degree: candidate?.highestEducation || "",
              },
            ],
            orgName: orgName,
          },
          childCredentials: null,
          isChild: isParent ? false : true
        };

        try {
          const response = await getMonsterResumeImport(candidateData);
          // const newCandidate = response?.data?.data?.response;
          // const { old, new: newResponse } = newCandidate;  
          const newCandidate = response?.data?.data?.response ?? {};
          const { old = null, new: newResponse = null } = newCandidate;
          const monsterExistingCandidates = response?.field?.existingCandidates || [];

          if (response.success) {
            if (old && newResponse) {
              setIsMergeModel(true);
              setCbExistingResponse(newCandidate);
            } else {
              const existing = candidate;
              dispatch(
                updateMonsterApplicantsDataStart({
                  existing,
                  newCandidate,
                  tableResponse: mTableResponse,
                  fullResponse: mFullResponse,
                  existingCandidates: mExistingCandidates,
                })
              );
              showToast("Resume Pulled Successfully", "success", 2000);
            }
          } else {
            if (response?.error == "Candidate already exists with the resumeId") {
              const existing = candidate;
              dispatch(
                updateMonsterApplicantsDataStart({
                  existing,
                  newCandidate: monsterExistingCandidates[0] || {},
                  tableResponse: mTableResponse,
                  fullResponse: mFullResponse,
                  existingCandidates: mExistingCandidates,
                })
              );
              showToast("Resume Pulled Successfully", "success", 2000);
            }
            else {
              if (response?.error) {
                showToast(response?.error, "error", 2000);
              } else {
                showToast("Resume Pulling Unsuccessful.", "error", 2000);
              }
              drawerClose();
            }
            dispatch(revertStateLoading());
          }
        } catch (error) {
          showToast("Something went wrong.", "error");
          drawerClose();
          dispatch(revertStateLoading());
        }

        break;
      }
      default:
        console.log("No matching source found.");
    }
    dispatch(revertStateLoading());
  };

  const checkAndGetIfResumeExists = () => {
    switch (source) {
      case 1: {
        if (candidate?.resumes?.length > 0) {
          const resumesLength = candidate?.resumes?.length;
          const resumeDoc = candidate?.resumes[resumesLength - 1];
          const filesLength = resumeDoc?.files?.length;

          const latestResume = resumeDoc?.files[filesLength - 1]?.html;
          return latestResume || "Resume not available";
        } else { return candidate?.htmlResume || "Resume not available"; }
        break;
      }

      case 2: {
        if (candidate?.resumes?.length > 0) {
          const resumesLength = candidate?.resumes?.length;
          const resumeDoc = candidate?.resumes[resumesLength - 1];
          const filesLength = resumeDoc?.files?.length;

          const latestResume = resumeDoc?.files[filesLength - 1]?.html;
          return latestResume || "Resume not available";
        } else if(candidate?.uiid){
          if (candidate?.resumes?.length === 0) {
            return  "Resume not available";
          }
        }

        break;
      }
      case 3: {
        if (candidate?.resumes?.length > 0) {
          const resumesLength = candidate?.resumes?.length;
          const resumeDoc = candidate?.resumes[resumesLength - 1];
          const filesLength = resumeDoc?.files?.length;
          const latestResume = resumeDoc?.files[filesLength - 1]?.html;
          return latestResume || "Resume not available";
        }else if(candidate?.uiid){
          if (candidate?.resumes?.length === 0) {
          return  "Resume not available";
          }
        }


        break;
      }
    }
  };
  //console.log(candidate)
  const resumeDetails = countKeywordsInResume(
    showOriginal ? viewData : checkAndGetIfResumeExists(),
    keywords
  );
  const highlighted = highlightKeywordsInHtmlResume(
    showOriginal ? viewData : checkAndGetIfResumeExists(),
    keywords
  );

  useEffect(() => {
    dispatch(setStateLoading());
    const exists = checkAndGetIfResumeExists();
    setGetResume((prev) => (prev !== exists ? exists : prev));

    dispatch(revertStateLoading());
  }, [candidate]);

  useEffect(() => {
    if (isOpen) {
      const fetchIntegrationAccess = () => {
        const params = {
          coll: "IntegrationAccess",
          fil: {
            userId: {
              type: "FIND_INTIGRATION_ACCESS",
              value: loginUserUiid,
              category: 3,
              categoryType: 2,
              status: 1
            },
          },
          useAggregate: true,
        };
        dispatch(setcareerBuilderAccessidStart(params));
      };

      const fetchMonsterIntegrationAccess = () => {
        const params = {
          coll: "IntegrationAccess",
          fil: {
            userId: {
              type: "FIND_INTIGRATION_ACCESS",
              value: loginUserUiid,
              category: 3,
              categoryType: 1,
              status: 1
            },
          },
          useAggregate: true,
        };
        dispatch(setMonsterAccessidStart(params));
      };

      if (source == 2) {
        fetchIntegrationAccess();
      } else if (source == 3 || source == "Monster") {
        fetchMonsterIntegrationAccess();
      }
    }
  }, [isOpen]);

  useEffect(() => {
    if (accessData?.careerBuilder?.[0]?.uiid) {
      setCbAccessId(accessData.careerBuilder[0].uiid);
      if (accessData.careerBuilder[0].integrationData?.status !== 1) {
        showToast(
          "Career Builder integration access not found. Please contact the administrator",
          "error"
        );
      }
    }
  }, [accessData?.careerBuilder]);

  useEffect(() => {
    if (accessData?.monster?.[0]?.uiid) {
      setMonsterAccessId(accessData.monster[0].uiid);
      if (accessData.monster[0].integrationData?.status !== 1) {
        showToast(
          "Monster integration access not found. Please contact the administrator",
          "error"
        );
      }
    }
  }, [accessData?.monster]);

  // console.log(candidate)

  // const resumeDetails = [
  //   {
  //     title: "Professional Engineering",
  //     value: 0,
  //   },
  //   {
  //     title: "Professional Engineer",
  //     value: 2,
  //   },
  //   {
  //     title: "Complex Category 2",
  //     value: 0,
  //   },
  //   {
  //     title: "Transportation",
  //     value: 3,
  //   },
  //   {
  //     title: "Construction",
  //     value: 18,
  //   },
  //   {
  //     title: "Inspection",
  //     value: 4,
  //   },
  //   {
  //     title: "Inspecting",
  //     value: 0,
  //   },
  //   {
  //     title: "Inspector",
  //     value: 0,
  //   },
  //   {
  //     title: "Bridge",
  //     value: 3,
  //   },
  //   {
  //     title: "Civil",
  //     value: 3,
  //   },
  //   {
  //     title: "CC2",
  //     value: 0,
  //   },
  //   {
  //     title: "P.E",
  //     value: 0,
  //   },
  //   {
  //     title: "P/E",
  //     value: 4,
  //   },
  //   {
  //     title: "PE",
  //     value: 1,
  //   },
  // ];

  function extractS3Key(url) {
    return url.replace(/^https?:\/\/[^/]+\//, "");
  }

  const viewResume = async () => {
    // If already fetched, just toggle
    if (hasFetched) {
      setShowOriginal((prev) => !prev);
      return;
    }

    try {
      const query = new URLSearchParams({
        key: extractS3Key(resumeLink),
        coll: "Candidate",
        html: true,
      }).toString();
      const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;
      const response= await axiosRequest({method:"GET",url})
      if(response?.success){
         const data = `<pre>${response?.data?.data?.htmlContent}</pre>`;
      setViewData(data);
      setHasFetched(true);
      setShowOriginal(true); // switch to original view after fetch

      }else{
        showToast("error fetching clear Resume", "error")
        setHasFetched(true);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setHasFetched(true);
    }
  };

  return !getResume ? (
    <div className="min-h-100 gap-4 flex  flex-col justify-center items-center">
      <p>
        By Clicking here, Credits will be used, and you will unlock the resume.
      </p>
      <Button
        title={"Get the Resume"}
        className="self-center"
        onClick={async () => {
          await downloadResumeForCandidate();
        }}
      />
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>

      <Modal
        isOpen={isMergeModel}
        onClose={() => {
          setIsMergeModel(false);
        }}
        title="Applicant Profile Migration"
        titleColor="primary"
        width="max-w-2xl"
      >
        <ProfileMigrationModel
          onCancel={() => {
            // drawerClose();
            setIsMergeModel(false);
          }}
          candidate={candidate}
          data={cbExistingResponse}
          source={source}
        />
      </Modal>
    </div>
  ) : (
    <div className="p-3">
      <div className="flex flex-wrap gap-2 mb-5">
        {Array.from({ length: resumeDetails.length }, (_, i) => (
          <Chip
            key={i}
            label={`${resumeDetails[i].title}-${resumeDetails[i].value}`}
            color={"info"}
            variant={"contained"}
            className="!bg-gray-50 !py-1 !border !border-info-100 text-info rounded-xl"
          />
        ))}
      </div>
      <div className="flex items-center my-3">
        <span>Migrated by</span>
        <div className="mx-2">
          <Chip
            label={
              formatWords2(candidate?.addedBy?.firstName) || candidate?.addedBy
            }
            color={"success"}
            icon={"person"}
            variant={"contained"}
            size="md"
            className="text-success !px-2"
          />
        </div>
        <span>from</span>
        <div className="mx-2">
          <Chip
            label={getJobBoardsName[candidate?.source]}
            color={"leave"}
            icon={"cloud_download"}
            variant={"contained"}
            size="md"
            className="text-leave !px-2"
          />
        </div>
        <span>on</span>
        <div className="mx-2">
          <Chip
            label={dateFormator(
              candidate?.addedOn || candidate?.modifiedOn,
              "datetime-ampm"
            )}
            icon={"calendar_month"}
            color="primary"
            variant={"contained"}
            size="md"
            className="text-primary !px-2"
          />
        </div>
      </div>
      {/* <p>
        Trouble viewing resume?{" "}
        <span className="text-blue-700 font-[700]">Click Here</span>
      </p> */}
      {/* <div className="flex flex-col flex-1 bg-gray-50 rounded p-4">
        <p className="mb-4">
          David J. Mosure, <mark>PE</mark>
          <br />
          Vice President, ms consultants, inc.
        </p>

        <p>
          Mr. Mosure, a professional engineer since 1983, brings 38 years’
          experience with public works infrastructure projects covering nearly
          every branch of
          <mark> construction</mark> administration;
          <mark> civil </mark>, environmental, mechanical and electrical
          engineering...
        </p>
      </div> */}

      <p>
        Trouble viewing resume?{" "}
          <span
            className={`font-[700] ${isDisabled
                ? "text-gray-400 cursor-not-allowed"
                : "text-blue-700 cursor-pointer"
              }`}
            onClick={!isDisabled ? viewResume : undefined}
          >
            {showOriginal ? "View Original Resume" : "View Clear Resume"}
          </span>
      </p>

      <div className="w-full">
        <div
          dangerouslySetInnerHTML={{
            __html: highlighted,
          }}
          className="[&_pre]:whitespace-pre-wrap [&_pre]:break-words [&_pre]:overflow-x-auto"
        />
      </div>

      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default Resume;
